import qs from 'qs';
import cleanDeep from 'clean-deep';

import { toUnderscoreObject } from 'helpers/toUnderscore';
import dotToPath from 'helpers/dotToPath';

const composeUrl = (url, { page, perPage, filters, sort, search }) => {
  const urlData = {
    filters: toUnderscoreObject(dotToPath(cleanDeep(filters)), false),
    sort: toUnderscoreObject(sort)
  };

  if (page) {
    urlData.page = page;
  }

  if (perPage) {
    urlData.count = perPage;
  }

  if (search) {
    urlData.search = search;
  }

  const queryString = qs.stringify(urlData, { arrayFormat: 'index' });
  return url + (queryString && '?' + queryString);
};

export default composeUrl;
